import { Controller } from "@hotwired/stimulus";

// Narrates the document-upload extraction as a stepped checklist while the
// sibling status-poll controller waits for the real result. The steps map to the
// actual pipeline (read doc -> extract fields -> match template -> resolve
// suppliers -> finalise) but advance on a timer; the page navigates away as
// soon as status-poll sees completion. Cosmetic only.
export default class extends Controller {
  static targets = ["step"];
  static values = { interval: { type: Number, default: 1800 } };

  connect() {
    this.current = -1;
    this.advance();
    this.timer = setInterval(() => this.advance(), this.intervalValue);
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer);
  }

  advance() {
    // Mark the previously-active step done.
    if (this.current >= 0 && this.current < this.stepTargets.length) {
      const previous = this.stepTargets[this.current];
      previous.classList.remove("is-active");
      previous.classList.add("is-done");
    }

    this.current += 1;

    if (this.current >= this.stepTargets.length) {
      // Hold on the final step (pulsing) until status-poll redirects.
      clearInterval(this.timer);
      const last = this.stepTargets[this.stepTargets.length - 1];
      last.classList.remove("is-done");
      last.classList.add("is-active");
      return;
    }

    this.stepTargets[this.current].classList.add("is-active");
  }
}
